export default {
  // Common
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  create: 'Crear',
  close: 'Cerrar',
  search: 'Buscar',
  filter: 'Filtrar',
  loading: 'Cargando...',
  noData: 'Sin datos',
  retry: 'Reintentar',
  confirm: 'Confirmar',
  back: 'Volver',
  next: 'Siguiente',
  previous: 'Anterior',
  yes: 'Sí',
  no: 'No',
  all: 'Todos',
  required: 'Obligatorio',
  optional: 'Opcional',

  // Auth
  login: 'Iniciar sesión',
  logout: 'Cerrar sesión',
  email: 'Email',
  password: 'Contraseña',
  forgotPassword: '¿Olvidaste tu contraseña?',
  resetPassword: 'Restablecer contraseña',
  register: 'Registrarse',
  wrongCredentials: 'Credenciales incorrectas',
  accountLocked: 'Cuenta bloqueada temporalmente',
  sessionExpired: 'Tu sesión ha expirado',

  // Navigation
  dashboard: 'Panel',
  requests: 'Solicitudes',
  clients: 'Clientes',
  professionals: 'Profesionales',
  vehicles: 'Vehículos',
  calendar: 'Calendario',
  billing: 'Facturación',
  invoices: 'Facturas',
  quotes: 'Presupuestos',
  settings: 'Ajustes',
  reporting: 'Informes',
  checklists: 'Checklists',
  support: 'Soporte',

  // Request statuses
  status: {
    requested: 'Solicitada',
    quoted: 'Presupuestada',
    accepted: 'Aceptada',
    pending_payment: 'Pte. Pago',
    ready: 'Preparada',
    active_service: 'En servicio',
    completed: 'Completada',
    rejected: 'Rechazada',
    archived: 'Archivada',
    cancelled: 'Cancelada',
    paid: 'Pagada',
    sent: 'Enviada',
    draft: 'Borrador',
    overdue: 'Vencida',
  },

  // Roles
  role: {
    superadmin: 'Super Admin',
    admin: 'Administrador',
    client: 'Cliente',
    professional: 'Profesional',
    ambulance: 'Recurso/Ambulancia',
  },

  // Actions
  generateQuote: 'Generar presupuesto',
  sendQuote: 'Enviar presupuesto',
  signQuote: 'Firmar presupuesto',
  rejectQuote: 'Rechazar presupuesto',
  prepareService: 'Preparar servicio',
  activateService: 'Activar servicio',
  finishService: 'Finalizar servicio',
  assignVehicle: 'Asignar vehículo',
  assignProfessional: 'Asignar profesional',
  autoAssign: 'Auto-asignar',
  validatePayment: 'Validar pago',
  downloadPdf: 'Descargar PDF',
  archive: 'Archivar',
  reopen: 'Reabrir',

  // Notifications
  notification: {
    newRequest: 'Nueva solicitud',
    quoteSigned: 'Presupuesto firmado',
    newInvoice: 'Nueva factura',
    serviceActivated: 'Servicio activado',
    serviceCompleted: 'Servicio completado',
    assignmentProposed: 'Nueva asignación propuesta',
    markAllRead: 'Marcar todas como leídas',
    noNotifications: 'Sin notificaciones',
  },

  // Invoice
  invoice: {
    number: 'Número de factura',
    concept: 'Concepto',
    amount: 'Importe',
    issueDate: 'Fecha emisión',
    dueDate: 'Fecha vencimiento',
    overdue: 'Vencida',
    dueSoon: 'Vence pronto',
    subtotal: 'Subtotal',
    tax: 'IVA',
    total: 'Total',
  },

  // Professional
  professional: {
    specialization: 'Especialización',
    hoursWorked: 'Horas trabajadas',
    totalEarned: 'Total facturado',
    settlements: 'Liquidaciones',
    availability: 'Disponibilidad',
    pendingProposals: 'Propuestas pendientes',
    accept: 'Aceptar',
    reject: 'Rechazar',
    countdown: 'Tiempo restante',
  },

  // Resource / Ambulance
  resource: {
    departureBase: 'Salida de base',
    enRoute: 'En ruta',
    arrival: 'Llegada',
    onSite: 'En servicio',
    finishing: 'Finalizando',
    returnBase: 'Vuelta a base',
    closed: 'Cerrado',
    estimatedDeparture: 'Hora estimada de salida',
    crewSignature: 'Firma del equipo',
    checklist: 'Checklist material',
    incidents: 'Incidencias',
  },

  // Errors
  error: {
    generic: 'Ha ocurrido un error. Inténtalo de nuevo.',
    network: 'Error de conexión. Verifica tu internet.',
    notFound: 'No encontrado',
    forbidden: 'No tienes permisos para esta acción',
    validation: 'Revisa los campos marcados',
  },

  // Time
  time: {
    now: 'ahora',
    minutesAgo: 'hace {n} min',
    hoursAgo: 'hace {n}h',
    daysAgo: 'hace {n}d',
    today: 'Hoy',
    tomorrow: 'Mañana',
    inDays: 'En {n} días',
  },
};
